/*
Melamine

--fireRated <boolean::checkbox>
--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Melamine'
const id = 'CEIVTreH4nt2lh5gQDWV'

export default {
  name,
  id,
  filters,
  headers,
  form
}
